// Note: The first file of a module here, must also register the module

import "./confirm-payment.component";
import "./no-permission-upgrade.component";
import "./payment-form.component";
import "./plan-info.component";
import "./select-plan-dialog.component";
import "./select-plan-form.component";
import "./stripe-card-form.component";
import "./upgrade-plan-dialog.component";
import "./upgrade-plan-form.component";
import "./upgrade-pending.component";
